import withTranslation from '../../../globals/components/withTranslation'
import Component from './component'
import { IUserActionsProps } from '../actions/types'

export default withTranslation(Component) as React.ComponentClass<IUserActionsProps>
